export { default } from './edit-2'
